import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { BatteryType } from "src/app/services/event.service";

interface HeaderData {
  "Pack Id": string;
  "Test ID": string;
  Date: string;
  "BMS ID": string;
  "Product ID": string;
  "Variant ID": string;
  "Test Type": string;
}

interface DialogueData {
  test_id: string;
  date: string;
  pack_data: { [key: string]: string };
  metaData: { [key: string]: string };
  battery_type: BatteryType;
  metaDataByGroup: {
    [key: string]: { [key: string]: string }[];
  };
}

@Component({
  selector: "app-metadata-dialouge",
  templateUrl: "./metadata-dialouge.component.html",
  styleUrls: ["./metadata-dialouge.component.css"],
})
export class PdiMetadataDialougeComponent implements OnInit, AfterViewInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogueData,
    private dialogueRef: MatDialogRef<PdiMetadataDialougeComponent>
  ) {}

  @ViewChild("dialogueHeader") dialogueHeader: ElementRef<HTMLDivElement>;
  @ViewChild("dialogueData") dialogueDataRef: ElementRef<HTMLDivElement>;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.generateHeaderData({
      date: this.data.date,
      packData: this.data.pack_data,
      test_id: this.data.test_id,
    });
    const metaDataContainer = this.dialogueDataRef.nativeElement;
    generateGroupBasedMetaData(
      this.data.metaData,
      metaDataContainer,
      this.data.battery_type
    );
    this.setDialougeMetadataStyle(metaDataContainer);
    //this.generateMetaData(this.data.metaData);

    // this.setDialougeStyles();
  }
  private setDialougeMetadataStyle(hostElement: HTMLDivElement) {
    hostElement
      .querySelectorAll(".group-header")
      .forEach((header: HTMLElement) => {
        header.setAttribute(
          "style",
          `
            background-color: #cfcfcf;
            padding: 0.2rem;
            font-size: 1rem;
            margin: 0px;
            border-bottom: 1px solid #b5b5b5;
            text-align: center;
            font-weight: 500;
            padding: 0.5rem;
          `
        );
      });

    hostElement
      .querySelectorAll(".group-data-container")
      .forEach((dataContainer: HTMLElement) => {
        dataContainer.setAttribute(
          "style",
          `
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0.5rem;
            background-color: #F1F1F1; 
            padding: 0.5rem; 
          `
        );
      });

    hostElement
      .querySelectorAll(".data-container")
      .forEach((dataContainer: HTMLDivElement) => {
        dataContainer.setAttribute(
          "style",
          `border: 1.2px solid #A3A3A3; background-color: rgb(199, 199, 199); text-align: center; font-size: 15px;`
        );

        const dataKey =
          dataContainer.querySelector<HTMLParagraphElement>(".data-key");
        const dataValue =
          dataContainer.querySelector<HTMLParagraphElement>(".data-value");

        dataKey.setAttribute(
          "style",
          `font-weight: 400; margin: 0px; padding: 0.5rem; `
        );

        dataValue.setAttribute(
          "style",
          ` font-weight: 500; margin: 0px; padding: 0.5rem; background-color: rgb(241, 241, 241); text-transform: capitalize;`
        );

        if (dataValue.textContent.trim().toLowerCase() === "fail") {
          dataContainer.style.border = "1.2px solid #b90000";
          dataContainer.style.backgroundColor = "#ff2f3640";
          dataKey.style.color = "#b90000";
          dataValue.style.color = "#b90000";
        }
      });
  }

  generateHeaderData(args: {
    packData: { [key: string]: string };
    test_id: string;
    date: string;
  }) {
    if (!args.packData) {
      const fallbackData = {
        "Test ID": args.test_id,
        Date: args.date,
      };

      Object.entries(fallbackData).forEach(([key, value]) => {
        const dataContianer = document.createElement("p");
        const dataKey = document.createElement("b");
        const dataValue = document.createElement("span");

        dataKey.textContent = key + ": ";
        dataValue.textContent = String(value);

        dataContianer.appendChild(dataKey);
        dataContianer.appendChild(dataValue);

        dataContianer.style.margin = "0";

        this.dialogueHeader.nativeElement.appendChild(dataContianer);
      });

      return;
    }

    const {
      date,
      test_id,
      packData: {
        bms_id,
        pack_id,
        product_id,
        sop_flash,
        test_type,
        variant_id,
      },
    } = args;

    const headerData: HeaderData = {
      "Test ID": test_id,
      Date: date,
      "Pack Id": pack_id,
      "BMS ID": bms_id,
      "Product ID": product_id,
      "Variant ID": variant_id,
      "Test Type": test_type,
    };

    const headerDataKeys = Object.keys(headerData);

    headerDataKeys.forEach((key) => {
      const dataContianer = document.createElement("p");
      const dataKey = document.createElement("b");
      const dataValue = document.createElement("span");

      dataKey.textContent = key + ": ";
      dataValue.textContent = headerData[key] ?? "---";

      dataContianer.appendChild(dataKey);
      dataContianer.appendChild(dataValue);

      dataContianer.style.margin = "0";

      this.dialogueHeader.nativeElement.appendChild(dataContianer);
    });
  }

  generateMetaData(metaData: { [key: string]: string | number }) {
    Object.entries(metaData).forEach(([key, value]) => {
      const dataContianer = document.createElement("div");
      const dataKey = document.createElement("p");
      const dataValue = document.createElement("p");

      dataKey.innerText = key;
      dataValue.innerText = String(value);

      dataValue.style.fontWeight = "500";
      dataValue.style.margin = "0";
      dataValue.style.padding = "0.5rem";
      dataValue.style.backgroundColor = "rgb(241, 241, 241)";

      dataKey.style.fontWeight = "400";
      dataKey.style.margin = "0";
      dataKey.style.padding = "0.5rem";

      if (value.toString().toLowerCase().trim() === "fail") {
        dataContianer.style.border = "1.2px solid #b90000";
        dataContianer.style.backgroundColor = "#ff2f3640";

        dataKey.style.color = "#b90000";
        dataValue.style.color = "#b90000";
      } else {
        dataContianer.style.border = "1.2px solid rgba(163, 163, 163, 0.565)";
        dataContianer.style.backgroundColor = "rgb(199, 199, 199)";
      }

      dataContianer.style.textAlign = "center";
      dataContianer.style.fontSize = "15px";

      dataContianer.appendChild(dataKey);
      dataContianer.appendChild(dataValue);

      this.dialogueDataRef.nativeElement.appendChild(dataContianer);
    });
  }

  onDialogueClose() {
    this.dialogueRef.close();
  }
}
const getGroupBasedData = (
  data: { [key: string]: string | number },
  battery_type: BatteryType
) => {
  interface GroupingData {
    group: string;
    label: string;
  }

  const tgGroupingData: GroupingData[] = [
    { group: "CAN Parameters", label: "batry_unique_key" },
    { group: "CAN Parameters", label: "bms_unique_key" },
    { group: "CAN Parameters", label: "bms_hw_version_exp" },
    { group: "CAN Parameters", label: "charge_cycle_count_bms" },
    { group: "CAN Parameters", label: "bms_curr_exp" },
    { group: "CAN Parameters", label: "user_soc" },
    { group: "CAN Parameters", label: "adc_curr_mcu" },
    { group: "Firmware Verification", label: "bl_fw_ver" },
    { group: "Firmware Verification", label: "app_fw_ver" },
    { group: "Firmware Verification", label: "app_hw_fw_ver" },
    { group: "Voltage Range", label: "voltage_cell_1" },
    { group: "Voltage Range", label: "voltage_cell_2" },
    { group: "Voltage Range", label: "voltage_cell_3" },
    { group: "Voltage Range", label: "voltage_cell_4" },
    { group: "Voltage Range", label: "voltage_cell_5" },
    { group: "Voltage Range", label: "voltage_cell_6" },
    { group: "Voltage Range", label: "voltage_cell_7" },
    { group: "Voltage Range", label: "voltage_cell_8" },
    { group: "Voltage Range", label: "voltage_cell_9" },
    { group: "Voltage Range", label: "voltage_cell_10" },
    { group: "Voltage Range", label: "voltage_cell_11" },
    { group: "Voltage Range", label: "voltage_cell_12" },
    { group: "Voltage Range", label: "voltage_cell_13" },
    { group: "Voltage Range", label: "voltage_cell_14" },
    { group: "Voltage Range", label: "voltage_cell_15" },
    { group: "Voltage Range", label: "voltage_cell_16" },
    { group: "Thermistor Range", label: "thermistor_1" },
    { group: "Thermistor Range", label: "thermistor_2" },
    { group: "Thermistor Range", label: "thermistor_3" },
    { group: "Thermistor Range", label: "thermistor_4" },
    { group: "Thermistor Range", label: "thermistor_5" },
    { group: "Thermistor Range", label: "thermistor_6" },
    { group: "Thermistor Range", label: "thermistor_7" },
    { group: "Thermistor Range", label: "thermistor_8" },
    { group: "Thermistor Range", label: "thermistor_9" },
    { group: "Thermistor Range", label: "thermistor_10" },
    { group: "Thermistor Range", label: "thermistor_11" },
    { group: "Thermistor Range", label: "thermistor_12" },
    { group: "Thermistor Range", label: "thermistor_13" },
    { group: "Thermistor Range", label: "thermistor_14" },
    { group: "Thermistor Range", label: "thermistor_15" },
    { group: "Thermistor Range", label: "thermistor_16" },
    { group: "Contactor Health Check", label: "dischrg_cont_hlth_chck_val" },
    { group: "Contactor Health Check", label: "dischrg_cont_wld_chck_val" },
    { group: "Contactor Health Check", label: "chrg_cont_hlth_chck_val" },
    { group: "Contactor Health Check", label: "chrg_cont_wld_chck_val" },
    { group: "Insulation Resistance", label: "ir_pos_ins_val" },
    { group: "Insulation Resistance", label: "ir_chrg_neg_ins_val" },
    { group: "Insulation Resistance", label: "ir_dis_neg_ins_val" },
    { group: "Visual Inspection", label: "visual_insp_1" },
    { group: "Visual Inspection", label: "visual_insp_2" },
    { group: "Visual Inspection", label: "visual_insp_3" },
    { group: "Visual Inspection", label: "visual_insp_4" },
    { group: "Visual Inspection", label: "visual_insp_5" },
    { group: "Visual Inspection", label: "visual_insp_6" },
    { group: "Visual Inspection", label: "visual_insp_7" },
    { group: "Visual Inspection", label: "visual_insp_8" },
    { group: "Visual Inspection", label: "visual_insp_9" },
    { group: "Visual Inspection", label: "visual_insp_10" },
    { group: "Visual Inspection", label: "visual_insp_11" },
    { group: "Visual Inspection", label: "visual_insp_12" },
    { group: "Visual Inspection", label: "visual_insp_13" },
    { group: "Visual Inspection", label: "visual_insp_14" },
    { group: "Visual Inspection", label: "visual_insp_15" },
    { group: "Visual Inspection", label: "visual_insp_16" },
    { group: "Visual Inspection", label: "visual_insp_17" },
    { group: "Visual Inspection", label: "visual_insp_18" },
    { group: "Visual Inspection", label: "visual_insp_19" },
    { group: "Visual Inspection", label: "visual_insp_20" },
    { group: "Visual Inspection", label: "visual_insp_21" },
    { group: "Visual Inspection", label: "visual_insp_22" },
    { group: "Visual Inspection", label: "visual_insp_23" },
    { group: "Visual Inspection", label: "visual_insp_24" },
    { group: "Visual Inspection", label: "visual_insp_25" },
    { group: "Visual Inspection", label: "visual_insp_26" },
    { group: "Visual Inspection", label: "visual_insp_27" },
    { group: "Visual Inspection", label: "visual_insp_28" },
    { group: "Visual Inspection", label: "visual_insp_29" },
    { group: "Visual Inspection", label: "visual_insp_30" },
    { group: "Visual Inspection", label: "visual_insp_31" },
    { group: "Visual Inspection", label: "visual_insp_32" },
    { group: "Visual Inspection", label: "visual_insp_33" },
    { group: "Visual Inspection", label: "visual_insp_34" },
    { group: "Visual Inspection", label: "visual_insp_35" },
    { group: "Visual Inspection", label: "visual_insp_36" },
    { group: "Visual Inspection", label: "visual_insp_37" },
    { group: "Visual Inspection", label: "visual_insp_38" },
    { group: "Visual Inspection", label: "visual_insp_39" },
    { group: "Visual Inspection", label: "visual_insp_40" },
    { group: "Visual Inspection", label: "visual_insp_41" },
    { group: "Visual Inspection", label: "visual_insp_42" },
    { group: "Visual Inspection", label: "visual_insp_43" },
    { group: "Visual Inspection", label: "visual_insp_44" },
    { group: "Visual Inspection", label: "visual_insp_45" },
    { group: "Visual Inspection", label: "visual_insp_46" },
    { group: "Visual Inspection", label: "visual_insp_47" },
    { group: "Visual Inspection", label: "visual_insp_48" },
    { group: "Visual Inspection", label: "visual_insp_49" },
    { group: "Visual Inspection", label: "visual_insp_50" },
    { group: "Extra Metadata", label: "sop_bms" },
    { group: "Extra Metadata", label: "soh_bms" },
    { group: "Extra Metadata", label: "cov_bms_hist" },
    { group: "Extra Metadata", label: "cuv_bms_hist" },
    { group: "Extra Metadata", label: "pov_bms_hist" },
    { group: "Extra Metadata", label: "puv_bms_hist" },
    { group: "Extra Metadata", label: "coc_bms_hist" },
    { group: "Extra Metadata", label: "doc_bms_hist" },
    { group: "Extra Metadata", label: "cot_bms_hist" },
    { group: "Extra Metadata", label: "dot_bms_hist" },
    { group: "Extra Metadata", label: "cut_bms_hist" },
    { group: "Extra Metadata", label: "dut_bms_hist" },
    { group: "Extra Metadata", label: "cso_bms_hist" },
    { group: "Extra Metadata", label: "ib_bms_hist" },
    { group: "Extra Metadata", label: "tso_bms_hist" },
    { group: "Extra Metadata", label: "scf_bms_hist" },
    { group: "Extra Metadata", label: "roc_bms_hist" },
    { group: "Extra Metadata", label: "sc_coc_bms_hist" },
    { group: "Re-PDI ", label: "re_pdi_reason" },
    { group: "Re-PDI ", label: "re_pdi_count" },
    { group: "Results", label: "batry_unique_key_result" },
    { group: "Results", label: "bms_unique_key_result" },
    { group: "Results", label: "bms_hw_version_exp_result" },
    { group: "Results", label: "charge_cycle_count_bms_result" },
    { group: "Results", label: "bms_curr_exp_result" },
    { group: "Results", label: "user_soc_result" },
    { group: "Results", label: "bl_fw_ver_result" },
    { group: "Results", label: "app_fw_ver_result" },
    { group: "Results", label: "app_hw_fw_ver_result" },
    { group: "Results", label: "voltage_cell_range_result" },
    { group: "Results", label: "thermistor_range_result" },
    { group: "Results", label: "dischrg_cont_hlth_result" },
    { group: "Results", label: "dischrg_cont_wld_result" },
    { group: "Results", label: "chrg_cont_hlth_result" },
    { group: "Results", label: "chrg_cont_wld_result" },
    { group: "Results", label: "ir_pos_ins_result" },
    { group: "Results", label: "ir_chrg_neg_ins_result" },
    { group: "Results", label: "ir_dis_neg_ins_result" },
    { group: "Results", label: "visual_insp_result_1" },
    { group: "Results", label: "visual_insp_result_2" },
    { group: "Results", label: "visual_insp_result_3" },
    { group: "Results", label: "visual_insp_result_4" },
    { group: "Results", label: "visual_insp_result_5" },
    { group: "Results", label: "visual_insp_result_6" },
    { group: "Results", label: "visual_insp_result_7" },
    { group: "Results", label: "visual_insp_result_8" },
    { group: "Results", label: "visual_insp_result_9" },
    { group: "Results", label: "visual_insp_result_10" },
    { group: "Results", label: "visual_insp_result_11" },
    { group: "Results", label: "visual_insp_result_12" },
    { group: "Results", label: "visual_insp_result_13" },
    { group: "Results", label: "visual_insp_result_14" },
    { group: "Results", label: "visual_insp_result_15" },
    { group: "Results", label: "visual_insp_result_16" },
    { group: "Results", label: "visual_insp_result_17" },
    { group: "Results", label: "visual_insp_result_18" },
    { group: "Results", label: "visual_insp_result_19" },
    { group: "Results", label: "visual_insp_result_20" },
    { group: "Results", label: "visual_insp_result_21" },
    { group: "Results", label: "visual_insp_result_22" },
    { group: "Results", label: "visual_insp_result_23" },
    { group: "Results", label: "visual_insp_result_24" },
    { group: "Results", label: "visual_insp_result_25" },
    { group: "Results", label: "visual_insp_result_26" },
    { group: "Results", label: "visual_insp_result_27" },
    { group: "Results", label: "visual_insp_result_28" },
    { group: "Results", label: "visual_insp_result_29" },
    { group: "Results", label: "visual_insp_result_30" },
    { group: "Results", label: "visual_insp_result_31" },
    { group: "Results", label: "visual_insp_result_32" },
    { group: "Results", label: "visual_insp_result_33" },
    { group: "Results", label: "visual_insp_result_34" },
    { group: "Results", label: "visual_insp_result_35" },
    { group: "Results", label: "visual_insp_result_36" },
    { group: "Results", label: "visual_insp_result_37" },
    { group: "Results", label: "visual_insp_result_38" },
    { group: "Results", label: "visual_insp_result_39" },
    { group: "Results", label: "visual_insp_result_40" },
    { group: "Results", label: "visual_insp_result_41" },
    { group: "Results", label: "visual_insp_result_42" },
    { group: "Results", label: "visual_insp_result_43" },
    { group: "Results", label: "visual_insp_result_44" },
    { group: "Results", label: "visual_insp_result_45" },
    { group: "Results", label: "visual_insp_result_46" },
    { group: "Results", label: "visual_insp_result_47" },
    { group: "Results", label: "visual_insp_result_48" },
    { group: "Results", label: "visual_insp_result_49" },
    { group: "Results", label: "visual_insp_result_50" },
    { group: "Results", label: "visual_inspection_result" },
    { group: "Results", label: "final_result" },
  ];
  const plGroupingData: GroupingData[] = [
    { group: "CAN Parameters", label: "m_bms_batry_unique_key" },
    { group: "CAN Parameters", label: "m_bms_bms_unique_key" },
    { group: "CAN Parameters", label: "m_bms_bms_hw_version_exp" },
    { group: "CAN Parameters", label: "m_bms_charge_cycle_count_bms" },
    { group: "CAN Parameters", label: "m_bms_bms_curr_exp" },
    { group: "CAN Parameters", label: "m_bms_user_soc" },
    { group: "CAN Parameters", label: "m_bms_adc_curr_mcu" },
    { group: "Firmware Verification", label: "m_bms_bl_fw_ver" },
    { group: "Firmware Verification", label: "m_bms_app_fw_ver" },
    { group: "Firmware Verification", label: "m_bms_app_hw_fw_ver" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_1" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_2" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_3" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_4" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_5" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_6" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_7" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_8" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_9" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_10" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_11" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_12" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_13" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_14" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_15" },
    { group: "Voltage Range", label: "m_bms_voltage_cell_16" },
    { group: "Thermistor Range", label: "m_bms_ct1" },
    { group: "Thermistor Range", label: "m_bms_ct2" },
    { group: "Thermistor Range", label: "m_bms_ct3" },
    { group: "Thermistor Range", label: "m_bms_ct4" },
    { group: "Thermistor Range", label: "m_bms_pt1" },
    { group: "Thermistor Range", label: "m_bms_pt2" },
    { group: "Thermistor Range", label: "m_bms_pt3" },
    { group: "Thermistor Range", label: "m_bms_pt4" },
    { group: "Thermistor Range", label: "m_bms_pt5" },
    { group: "Thermistor Range", label: "m_bms_pt6" },
    { group: "Thermistor Range", label: "m_bms_pt7" },
    {
      group: "Contactor Health Check",
      label: "m_bms_dischrg_cont_hlth_chck_val",
    },
    {
      group: "Contactor Health Check",
      label: "m_bms_dischrg_cont_wld_chck_val",
    },
    { group: "Contactor Health Check", label: "m_bms_chrg_cont_hlth_chck_val" },
    { group: "Contactor Health Check", label: "m_bms_chrg_cont_wld_chck_val" },
    { group: "Insulation Resistance", label: "m_bms_ir_pos_ins_val" },
    { group: "Insulation Resistance", label: "m_bms_ir_chrg_neg_ins_val" },
    { group: "Insulation Resistance", label: "m_bms_ir_dis_neg_ins_val" },
    { group: "Visual Inspection", label: "visual_insp_1" },
    { group: "Visual Inspection", label: "visual_insp_2" },
    { group: "Visual Inspection", label: "visual_insp_3" },
    { group: "Visual Inspection", label: "visual_insp_4" },
    { group: "Visual Inspection", label: "visual_insp_5" },
    { group: "Visual Inspection", label: "visual_insp_6" },
    { group: "Visual Inspection", label: "visual_insp_7" },
    { group: "Visual Inspection", label: "visual_insp_8" },
    { group: "Visual Inspection", label: "visual_insp_9" },
    { group: "Visual Inspection", label: "visual_insp_10" },
    { group: "Visual Inspection", label: "visual_insp_11" },
    { group: "Visual Inspection", label: "visual_insp_12" },
    { group: "Visual Inspection", label: "visual_insp_13" },
    { group: "Visual Inspection", label: "visual_insp_14" },
    { group: "Visual Inspection", label: "visual_insp_15" },
    { group: "Visual Inspection", label: "visual_insp_16" },
    { group: "Visual Inspection", label: "visual_insp_17" },
    { group: "Visual Inspection", label: "visual_insp_18" },
    { group: "Visual Inspection", label: "visual_insp_19" },
    { group: "Visual Inspection", label: "visual_insp_20" },
    { group: "Visual Inspection", label: "visual_insp_21" },
    { group: "Visual Inspection", label: "visual_insp_22" },
    { group: "Visual Inspection", label: "visual_insp_23" },
    { group: "Visual Inspection", label: "visual_insp_24" },
    { group: "Visual Inspection", label: "visual_insp_25" },
    { group: "Visual Inspection", label: "visual_insp_26" },
    { group: "Visual Inspection", label: "visual_insp_27" },
    { group: "Visual Inspection", label: "visual_insp_28" },
    { group: "Visual Inspection", label: "visual_insp_29" },
    { group: "Visual Inspection", label: "visual_insp_30" },
    { group: "Visual Inspection", label: "visual_insp_31" },
    { group: "Visual Inspection", label: "visual_insp_32" },
    { group: "Visual Inspection", label: "visual_insp_33" },
    { group: "Visual Inspection", label: "visual_insp_34" },
    { group: "Visual Inspection", label: "visual_insp_35" },
    { group: "Visual Inspection", label: "visual_insp_36" },
    { group: "Visual Inspection", label: "visual_insp_37" },
    { group: "Visual Inspection", label: "visual_insp_38" },
    { group: "Visual Inspection", label: "visual_insp_39" },
    { group: "Visual Inspection", label: "visual_insp_40" },
    { group: "Visual Inspection", label: "visual_insp_41" },
    { group: "Visual Inspection", label: "visual_insp_42" },
    { group: "Visual Inspection", label: "visual_insp_43" },
    { group: "Visual Inspection", label: "visual_insp_44" },
    { group: "Visual Inspection", label: "visual_insp_45" },
    { group: "Visual Inspection", label: "visual_insp_46" },
    { group: "Visual Inspection", label: "visual_insp_47" },
    { group: "Visual Inspection", label: "visual_insp_48" },
    { group: "Visual Inspection", label: "visual_insp_49" },
    { group: "Visual Inspection", label: "visual_insp_50" },
    { group: "Extra Metadata", label: "m_bms_sop" },
    { group: "Extra Metadata", label: "m_bms_soh" },
    { group: "Extra Metadata", label: "m_bms_cov" },
    { group: "Extra Metadata", label: "m_bms_cuv" },
    { group: "Extra Metadata", label: "m_bms_pov" },
    { group: "Extra Metadata", label: "m_bms_puv" },
    { group: "Extra Metadata", label: "m_bms_coc" },
    { group: "Extra Metadata", label: "m_bms_doc" },
    { group: "Extra Metadata", label: "m_bms_cot" },
    { group: "Extra Metadata", label: "m_bms_dot" },
    { group: "Extra Metadata", label: "m_bms_cut" },
    { group: "Extra Metadata", label: "m_bms_dut" },
    { group: "Extra Metadata", label: "m_bms_cso" },
    { group: "Extra Metadata", label: "m_bms_ib" },
    { group: "Extra Metadata", label: "m_bms_tso" },
    { group: "Extra Metadata", label: "m_bms_scf" },
    { group: "Extra Metadata", label: "m_bms_roc" },
    { group: "Extra Metadata", label: "m_bms_sc_coc" },
    { group: "Extra Metadata", label: "m_bms_icp" },
    { group: "Extra Metadata", label: "m_bms_ccuv" },
    { group: "Extra Metadata", label: "m_bms_sc_coc1" },
    { group: "Extra Metadata", label: "m_bms_ccov" },
    { group: "Extra Metadata", label: "m_bms_ib1" },
    { group: "Extra Metadata", label: "m_bms_afe_tp" },
    { group: "Extra Metadata", label: "m_bms_cnot" },
    { group: "Extra Metadata", label: "m_bms_doc1" },
    { group: "Extra Metadata", label: "m_bms_rm" },
    { group: "Extra Metadata", label: "m_bms_pvi" },
    { group: "Extra Metadata", label: "m_bms_dci" },
    { group: "Extra Metadata", label: "m_bms_cci" },
    { group: "Extra Metadata", label: "m_bms_coms" },
    { group: "Extra Metadata", label: "m_bms_cov_flag" },
    { group: "Extra Metadata", label: "m_bms_cuv_flag" },
    { group: "Extra Metadata", label: "m_bms_pov_flag" },
    { group: "Extra Metadata", label: "m_bms_puv_flag" },
    { group: "Extra Metadata", label: "m_bms_coc_flag" },
    { group: "Extra Metadata", label: "m_bms_doc_flag" },
    { group: "Extra Metadata", label: "m_bms_cot_flag" },
    { group: "Extra Metadata", label: "m_bms_dot_flag" },
    { group: "Extra Metadata", label: "m_bms_cut_flag" },
    { group: "Extra Metadata", label: "m_bms_dut_flag" },
    { group: "Extra Metadata", label: "m_bms_ib_flag" },
    { group: "Extra Metadata", label: "m_bms_tso_flag" },
    { group: "Extra Metadata", label: "m_bms_scf_flag" },
    { group: "Extra Metadata", label: "m_bms_roc_flag" },
    { group: "Extra Metadata", label: "m_bms_sc_coc_flag" },
    { group: "Extra Metadata", label: "m_bms_icp_flag" },
    { group: "Extra Metadata", label: "m_bms_ccuv_flag" },
    { group: "Extra Metadata", label: "m_bms_sc_coc1_flag" },
    { group: "Extra Metadata", label: "m_bms_ccov_flag" },
    { group: "Extra Metadata", label: "m_bms_ib1_flag" },
    { group: "Extra Metadata", label: "m_bms_afe_tp_flag" },
    { group: "Extra Metadata", label: "m_bms_cnot_flag" },
    { group: "Extra Metadata", label: "m_bms_doc1_flag" },
    { group: "Extra Metadata", label: "m_bms_rm_flag" },
    { group: "Extra Metadata", label: "m_bms_pvi_flag" },
    { group: "Extra Metadata", label: "m_bms_dci_flag" },
    { group: "Extra Metadata", label: "m_bms_cci_flag" },
    { group: "Extra Metadata", label: "m_bms_coms_flag" },
    { group: "Extra Metadata", label: "m_bms_cso_flag" },
    { group: "Re-PDI ", label: "re_pdi_reason" },
    { group: "Re-PDI ", label: "re_pdi_count" },
    { group: "Results", label: "m_bms_batry_unique_key_result" },
    { group: "Results", label: "m_bms_bms_unique_key_result" },
    { group: "Results", label: "m_bms_bms_hw_version_exp_result" },
    { group: "Results", label: "m_bms_charge_cycle_count_bms_result" },
    { group: "Results", label: "m_bms_bms_curr_exp_result" },
    { group: "Results", label: "m_bms_user_soc_result" },
    { group: "Results", label: "m_bms_bl_fw_ver_result" },
    { group: "Results", label: "m_bms_app_fw_ver_result" },
    { group: "Results", label: "m_bms_app_hw_fw_ver_result" },
    { group: "Results", label: "m_bms_voltage_cell_range_result" },
    { group: "Results", label: "m_bms_thermistor_range_result" },
    { group: "Results", label: "m_bms_dischrg_cont_hlth_result" },
    { group: "Results", label: "m_bms_dischrg_cont_wld_result" },
    { group: "Results", label: "m_bms_chrg_cont_hlth_result" },
    { group: "Results", label: "m_bms_chrg_cont_wld_result" },
    { group: "Results", label: "m_bms_ir_pos_ins_result" },
    { group: "Results", label: "m_bms_ir_chrg_neg_ins_result" },
    { group: "Results", label: "m_bms_ir_dis_neg_ins_result" },
    { group: "Results", label: "visual_insp_result_1" },
    { group: "Results", label: "visual_insp_result_2" },
    { group: "Results", label: "visual_insp_result_3" },
    { group: "Results", label: "visual_insp_result_4" },
    { group: "Results", label: "visual_insp_result_5" },
    { group: "Results", label: "visual_insp_result_6" },
    { group: "Results", label: "visual_insp_result_7" },
    { group: "Results", label: "visual_insp_result_8" },
    { group: "Results", label: "visual_insp_result_9" },
    { group: "Results", label: "visual_insp_result_10" },
    { group: "Results", label: "visual_insp_result_11" },
    { group: "Results", label: "visual_insp_result_12" },
    { group: "Results", label: "visual_insp_result_13" },
    { group: "Results", label: "visual_insp_result_14" },
    { group: "Results", label: "visual_insp_result_15" },
    { group: "Results", label: "visual_insp_result_16" },
    { group: "Results", label: "visual_insp_result_17" },
    { group: "Results", label: "visual_insp_result_18" },
    { group: "Results", label: "visual_insp_result_19" },
    { group: "Results", label: "visual_insp_result_20" },
    { group: "Results", label: "visual_insp_result_21" },
    { group: "Results", label: "visual_insp_result_22" },
    { group: "Results", label: "visual_insp_result_23" },
    { group: "Results", label: "visual_insp_result_24" },
    { group: "Results", label: "visual_insp_result_25" },
    { group: "Results", label: "visual_insp_result_26" },
    { group: "Results", label: "visual_insp_result_27" },
    { group: "Results", label: "visual_insp_result_28" },
    { group: "Results", label: "visual_insp_result_29" },
    { group: "Results", label: "visual_insp_result_30" },
    { group: "Results", label: "visual_insp_result_31" },
    { group: "Results", label: "visual_insp_result_32" },
    { group: "Results", label: "visual_insp_result_33" },
    { group: "Results", label: "visual_insp_result_34" },
    { group: "Results", label: "visual_insp_result_35" },
    { group: "Results", label: "visual_insp_result_36" },
    { group: "Results", label: "visual_insp_result_37" },
    { group: "Results", label: "visual_insp_result_38" },
    { group: "Results", label: "visual_insp_result_39" },
    { group: "Results", label: "visual_insp_result_40" },
    { group: "Results", label: "visual_insp_result_41" },
    { group: "Results", label: "visual_insp_result_42" },
    { group: "Results", label: "visual_insp_result_43" },
    { group: "Results", label: "visual_insp_result_44" },
    { group: "Results", label: "visual_insp_result_45" },
    { group: "Results", label: "visual_insp_result_46" },
    { group: "Results", label: "visual_insp_result_47" },
    { group: "Results", label: "visual_insp_result_48" },
    { group: "Results", label: "visual_insp_result_49" },
    { group: "Results", label: "visual_insp_result_50" },
    { group: "Results", label: "visual_inspection_result" },
    { group: "Results", label: "final_result" },
  ];

  const groupingDataList: Record<BatteryType, GroupingData[]> = {
    tg: tgGroupingData,
    piccolo: plGroupingData,
    hv: null,
  };

  const groupingData = groupingDataList[battery_type];

  groupingData.map((i) => ({
    group: i.group.trim(),
    label: i.label.trim().toLowerCase(),
  }));

  const trimmedData = Object.entries(data).map(([key, value]) => ({
    label: key.toLowerCase().trim(),
    value: String(value).toLowerCase().trim(),
  }));

  const uniqueHeaders = Array.from(new Set(groupingData.map((_) => _.group)));
  let dataByHeaders: { [key: string]: { [key: string]: string }[] } = {};

  uniqueHeaders.forEach((header) => {
    let currentHeaderData = [];
    const currentHeaderKeys = groupingData
      .filter((_) => _.group === header)
      .map((i) => i.label);

    currentHeaderKeys.forEach((key) => {
      const dataItem = trimmedData.find((_) => _.label === key)?.value;
      currentHeaderData.push({ [key]: dataItem ?? "NA" });
    });

    dataByHeaders[header] = currentHeaderData;
  });

  return dataByHeaders;
};
export const generateGroupBasedMetaData = (
  metaData: { [key: string]: string | number },
  metaDataContainer: HTMLDivElement,
  battery_type: BatteryType
) => {
  const data = getGroupBasedData(metaData, battery_type);
  let groups = Object.keys(data);
  const groupContainerStyle = `
      border: 1px solid #a3a3a3
    `;

  // let sortedGroups = [...groups].sort((a, b) => a.localeCompare(b));
  // sortedGroups.splice(sortedGroups.indexOf("Results"), 1);
  // sortedGroups.unshift("Results");

  groups.forEach((currentGroup) => {
    const groupContainer = document.createElement("div");
    const groupDataContainer = document.createElement("div");
    const groupHeader = document.createElement("h2");

    groupHeader.textContent = currentGroup;
    groupContainer.appendChild(groupHeader);
    groupContainer.appendChild(groupDataContainer);
    metaDataContainer.appendChild(groupContainer);

    const currentGroupData = data[currentGroup];
    currentGroupData.forEach((data) => {
      const dataContianer = document.createElement("div");
      const dataKey = document.createElement("p");
      const dataValue = document.createElement("p");
      const key = Object.keys(data)[0];
      const value = data[key] == "" ? "-" : data[key];
      dataKey.innerText = key;
      dataValue.innerText = String(value);

      dataValue.classList.add("data-value");
      dataKey.classList.add("data-key");
      dataContianer.classList.add("data-container");

      dataContianer.appendChild(dataKey);
      dataContianer.appendChild(dataValue);
      groupDataContainer.appendChild(dataContianer);
    });

    groupContainer.setAttribute("style", groupContainerStyle);

    groupDataContainer.classList.add("group-data-container");
    groupContainer.classList.add("group-container");
    groupHeader.classList.add("group-header");
  });
};
